// extracted by mini-css-extract-plugin
export default {"tariff-card":"HVMdY","preloader":"n9Usy"};